import { render } from "./TableSchema.vue?vue&type=template&id=dd749c5e&scoped=true"
import script from "./TableSchema.vue?vue&type=script&lang=js"
export * from "./TableSchema.vue?vue&type=script&lang=js"

import "./TableSchema.vue?vue&type=style&index=0&id=dd749c5e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd749c5e"]])

export default __exports__